import React from 'react'
import { type FieldValues, useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { CheckboxBase } from '../CheckboxBase'
import type { IProps } from './interfaces'

/** The kit's checkbox bound to react-hook-form; `CheckboxBase` is the same checkbox without a form. */
export const Checkbox = <TFieldValues extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  label,
  isDisabled = false,
  description,
  'data-testid': testId,
}: IProps<TFieldValues>): React.JSX.Element => {
  const { t } = useTranslation()
  const {
    field,
    fieldState: { error },
  } = useController({ name, control, rules, defaultValue })

  return (
    <CheckboxBase
      label={label}
      isSelected={!!field.value}
      onChange={field.onChange}
      isDisabled={isDisabled}
      isInvalid={!!error}
      description={description}
      errorMessage={error?.message ? t(error.message) : undefined}
      data-testid={testId}
    />
  )
}
